import config from "../config";

export const BASE_PATH = config.API_BASE_PATH;
export const URL_AUTH = "/auth/signin";